import React from 'react';
import './possibility.css';
import tractionTable from '../../assets/lcpt-traction-table.jpeg';

const Possibility = () => {
  return (
    <div className="gpt3__possibility section__padding" id="possibility">
      <div className="gpt3__possibility-image">
        <img src={tractionTable} alt="Mechanical traction decompression table at Lake Champlain Physical Therapy"/>
      </div>
      <div className="gpt3__possibility-content">
        <h4>Mechanical traction and decompression</h4>
        <h1 className="gradient__text">Non-surgical relief for low back, neck, and sciatica pain.</h1>
        <p>Lake Champlain Physical Therapy offers mechanical traction decompression and end-range passive decompression tables for patients dealing with sciatica, low back pain, neck pain, radiating symptoms, disc-related irritation, and spinal stiffness. Treatment is matched with hands-on physical therapy and targeted exercise to support lasting, non-surgical pain relief.</p>
        <h4>Call (518) 597-4678</h4>
      </div>
    </div>
  )
}

export default Possibility
